import React, { type ReactNode } from 'react';

import { clamp } from 'beeftools';

import { FilterChip } from '../FilterChip/FilterChip.tsx';

import { ClearAction, ClearActionLabel, Content, Interior, Label, Report } from './FiltersReport.style.ts';

export interface FiltersReportProps {
    resultsCount?: number;
    children?: ReactNode;
    onClear?: () => void;
}

export function FiltersReport({ resultsCount, children, onClear }: FiltersReportProps) {
    const safeCount = clamp(0, resultsCount, 99);
    const label = resultsCount === undefined ? 'Results' : `${safeCount} Results`;

    return (
        <Report>
            <Interior>
                <Content>
                    <Label>{label}</Label>

                    {children || <FilterChip label="No filters…" />}

                    <ClearAction ariaLabel="Remove all applied filters" disabled={!onClear} onAction={onClear}>
                        <ClearActionLabel>Clear all</ClearActionLabel>
                    </ClearAction>
                </Content>
            </Interior>
        </Report>
    );
}
